import React from "react";
import {useTheme} from "@mui/material";
import {MuiRhfTextField} from "./MuiRhfTextField";

export function MuiRhfNumberField(props: {
  name: string,
  label: string,
  unit?: string,
  required?: boolean,
  disabled?: boolean,
  fullWidth?: boolean,
}) {
  const theme = useTheme();

  return (
    <MuiRhfTextField
      sx={{marginRight: theme.spacing(2), width: '10em'}}
      name={props.name}
      label={props.label + (props.required ? ' *' : '')}
      unit={props.unit}
      disabled={props.disabled}
      variant={"outlined"}
      fullWidth={props.fullWidth}
      InputLabelProps={{
        shrink: true
      }}
      inputProps={{
        sx: {textAlign: 'right'}
      }}
    />
  )
}
